angular.module('lf.desktop')

.controller('ProductQuickviewCtrl', function ($scope) {
  $scope.popup.showTrailer = false;
  
  $scope.$on('popup:hidden', function () {
    $scope.popup.showTrailer = false;
  });
});
